import { Form, Select } from "../../../../../../../../shared/frontend/ui";
import { useI18n } from "../../../../app/i18n/useI18n";

/** Anlegefelder des CenterCom-Adapters: der Importumfang. */
export function CenterComCreateRunFields() {
  const { text } = useI18n();
  return (
    <Form.Item
      label={text("CenterCom import mode")}
      name="importMode"
      initialValue="Full"
      rules={[{ required: true, message: text("CenterCom import mode required") }]}
    >
      <Select
        options={[
          { label: text("CenterCom import mode Full"), value: "Full" },
          { label: text("CenterCom import mode BaseDataAndStaff"), value: "BaseDataAndStaff" }
        ]}
      />
    </Form.Item>
  );
}
